<template>
  <v-container class="containerFinder px-0 pt-0" :class="background ? 'backgroundHeader' : ''">
    <div class="headerFinder">
      <ImageWall :url="imgUrl('finder.jpg')">
        <div class="borderTitle">
          <p v-translate class="titleImg text-md-h5 text-subtitle-1">
            Meet new and interesting golfers to play with in your home courses or when you are on a trip
          </p>
        </div>
      </ImageWall>
      <v-row no-gutters class="afterImgWall" style="position: relative">
        <p v-translate class="font-weight-bold text-center mb-0 mb-sm-8">
          BGC Players Finder is the very first tool helps you to find suitable golf partners on a course with similar attitudes to the game and skill levels to play with all over the world.
        </p>
      </v-row>

      <v-row class="wallBtn px-4" no-gutters>
        <div class="buttonRegist">
          <v-btn
            width="100%"
            depressed
            :x-large="$vuetify.breakpoint.mdAndDown ? false : true"
            class="generalBtn text-none font-weight-bold text-md-h6 subtitle-1"
            :class="type === host ? 'lookingHostBtn' : 'beginHostBtn'"
            @click="$emit('setType', host)"
          >
            <translate>Being a Host</translate>
          </v-btn>
        </div>

        <div class="buttonLooking">
          <v-btn
            width="100%"
            depressed
            :x-large="$vuetify.breakpoint.mdAndDown ? false : true"
            class=" generalBtn text-none font-weight-bold text-md-h6 subtitle-1"
            :class="type === seeker ? 'lookingHostBtn' : 'beginHostBtn'"
            @click="$emit('setType', seeker)"
          >
            <translate>Looking for a Host</translate>
          </v-btn>
        </div>
      </v-row>
    </div>
    <v-row class="mt-md-14 mt-5 justify-center" no-gutters>

      <p class="font-weight-bold text-h6 px-4" :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '18px !important' : ''}">{{ title }}</p>
    </v-row>
  </v-container>
</template>

<script>
import ImageWall from "@/components/ImageWall";
export default {
  name: "FinderHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    type: {},
    background: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ImageWall
  },
  data() {
    return {
      host: PLAYER_HOST,
      seeker: PLAYER_SEEKER
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
  }
};
</script>
<style lang="scss">
</style>
